// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddQuestionnaire_codeEditorFrame__lUFKp {
  border: 1px solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  overflow: hidden;
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Questionnaires/AddQuestionnaire.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".codeEditorFrame {\n  border: 1px solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  overflow: hidden;\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"codeEditorFrame": `AddQuestionnaire_codeEditorFrame__lUFKp`
};
export default ___CSS_LOADER_EXPORT___;
